var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function backStepByPath(currentPath, previousPath) {
    var stepsRaw = localStorage.getItem("steps");
    if (!stepsRaw)
        return console.error("No se encontró el localStorage con clave 'steps'");
    var steps = JSON.parse(stepsRaw);
    if (!steps.length)
        return console.warn("El array de steps está vacío");
    var currentIndex = steps.findIndex(function (s) { return s.pathUrl === currentPath; });
    if (currentIndex === -1)
        return console.warn("No se encontr\u00F3 ning\u00FAn step con pathUrl: ".concat(currentPath));
    // Si no te pasan el path del anterior, asumimos el índice anterior
    var previousIndex = previousPath
        ? steps.findIndex(function (s) { return s.pathUrl === previousPath; })
        : currentIndex - 1;
    if (previousIndex < 0 || previousIndex >= steps.length)
        return console.warn("No se pudo determinar el step anterior.");
    // Actualiza estados (no toca details)
    steps[currentIndex] = __assign(__assign({}, steps[currentIndex]), { state: "initialState" });
    steps[previousIndex] = __assign(__assign({}, steps[previousIndex]), { state: "inProgress" });
    localStorage.setItem("steps", JSON.stringify(steps));
}
